import { OperationTime, OrderType, QCDowntimeCodes } from '../../../constants/Enum'
import { SHIFT } from '../../../constants/EnumType'
import { BulkStatus } from '../../../models'
import { formatNumber, getMinuteTimeV2 } from '../../../utilities/Format'
import { format } from 'date-fns'
import { isFeatureEnabled } from '../../../constants/FeatureFlag'

const OperationLogTable = ({ logs, onEdit, onDelete, showAllCol = false, isEdit = true, orderType, showCreatedBy = false, onViewLog }) => {
  const setupLogs = logs.filter(l => l.timeType === OperationTime.SETUP_TIME).sort((a, b) => (a.postingDate.localeCompare(b.postingDate) || a.startedTime - b.startedTime))
  const runLogs = logs.filter(l => l.timeType === OperationTime.RUN_TIME).sort((a, b) => (a.postingDate.localeCompare(b.postingDate) || a.startedTime - b.startedTime))
  const soapBaseLogs = logs.filter(l => l.timeType === OperationTime.SOAP_BASE).sort((a, b) => (a.postingDate.localeCompare(b.postingDate) || a.startedTime - b.startedTime))
  const downLogs = logs.filter(l => l.timeType === OperationTime.DOWN_TIME).sort((a, b) => (a.postingDate.localeCompare(b.postingDate) || a.startedTime - b.startedTime))

  const showReasonCode = isFeatureEnabled('SETUP_REASON_CODE')

  const isOperationConfirmed = (data) => {
    if(data && data.confirmationId) return true
    return false
  }

  return <table className="min-w-full divide-y divide-gray-200">
    <thead className='bg-gray-50'>
      <tr>
        <th scope="col" className='table-th'>BatchNo</th>
        <th scope="col" className='table-th'>Post.Date</th>
        {showAllCol ? <th scope="col" className='table-th'>Shift</th>:null}
        {showAllCol ? <th scope="col" className='table-th'>Mch</th>:null}
        <th scope="col" className='table-th'>เริ่ม</th>
        <th scope="col" className='table-th'>จบ</th>
        <th scope="col" className='table-th'>เวลารวม</th>
        <th scope="col" className='table-th'>RT</th>
        <th scope="col" className='table-th'>OT</th>
        <th scope="col" className='table-th'>ผลิตได้</th>
        {orderType === OrderType.BULK ? 
          <th scope="col" className='table-th'>Scrap</th> : 
          <th scope="col" className='table-th'>ใช้Bulk</th>
        }
        <th scope="col" className='table-th'>Down</th>
        {showCreatedBy ? <th scope="col" className='table-th'>บันทึกโดย</th> : null}
        <th scope="col" className='table-th' colSpan={3}>Action</th>
      </tr>
    </thead>
    <tbody className="text-center bg-white divide-y divide-gray-200">
      {logs.length === 0 ? <tr>
        <td colSpan={showAllCol ? 13: 11}>ไม่มีการบันทึก</td>
      </tr> : null}
      {setupLogs.length > 0 ?
      <tr className='bg-[#E2E2E2]'>
        <th colSpan={showAllCol ? 15: 13} className="px-2 text-sm text-left">Set Up</th>
      </tr> : null}
      {setupLogs.map(log =>
        <tr className={ isOperationConfirmed(log) ? 'tableOperationConfirmed' : ''} key={log.id}>
          <td>{log.batchNo ? log.batchNo : '-'}</td>
          <td>{format(new Date(log.postingDate), 'dd-MM-yyyy')}</td>
          {showAllCol ? <td>{displayShift(log.shift)}</td> :null}
          {showAllCol ? <td>{log.mch ? log.mch : '-'}</td> :null}
          <td>{log.startedTime ? format(new Date(log.startedTime * 1000), 'HH:mm') : "-"}</td>
          <td>{log.finishedTime ? format(new Date(log.finishedTime * 1000), 'HH:mm') : "-"}</td>
          <td>{log.totalTime ? `${getMinuteTimeV2(log.startedTime, log.finishedTime)} นาที` : '-'}</td>
          <td>{log.totalTime > 0 && log.totalEmployeeRT > 0 ? `${log.totalEmployeeRT} คน/${getMinuteTimeV2(log.startedTime, log.finishedTime)*log.totalEmployeeRT} นาที`: '-'}</td>
          <td>{log.totalTime > 0 && log.totalEmployeeOT > 0 ? `${log.totalEmployeeOT} คน/${getMinuteTimeV2(log.startedTime, log.finishedTime)*log.totalEmployeeOT} นาที`: '-'}</td>
          <td>-</td>
          <td>-</td>
          <td>{showReasonCode && log.reasonCode ? <span className='px-1 py-1 text-sm text-blue-500 border border-blue-500 rounded'>{log.reasonCode}</span> : '-'}</td>
          {showCreatedBy ? <td>{log.createdBy}</td> : null}
          {isOperationConfirmed(log) ?
            <td colspan="2" className='text-green-600'>ยืนยันแล้ว</td>
          :
            <>
              {isEdit ? <td className="work-center-edit" onClick={() => onEdit(log.id, log.downtimeCode)}>แก้ไข</td> : <td>-</td>}
              {isEdit ? <td><button className="px-2 py-1 text-xs text-white bg-red-500 rounded" onClick={() => onDelete(log.id, log.downtimeCode)}>ลบ</button></td> : <td>-</td>}
              <td className="work-center-edit"  onClick={() => onViewLog(log.id)}>ดู</td>
            </>
          }
        </tr>
      )}
      {runLogs.length > 0 ?
      <tr className="bg-[#e2e2e2]">
        <th colSpan={showAllCol ? 15: 13} className="px-2 text-sm text-left">Run Time</th>
      </tr> : null}
      {runLogs.map(log =>
        <tr className={ isOperationConfirmed(log) ? 'tableOperationConfirmed' : ''} key={log.id}>
          <td>{log.batchNo ? log.batchNo : '-'}</td>
          <td>{format(new Date(log.postingDate), 'dd-MM-yyyy')}</td>
          {showAllCol ? <td>{displayShift(log.shift)}</td> :null}
          {showAllCol ? <td>{log.mch ? log.mch : '-'}</td> :null}
          <td>{log.startedTime ? format(new Date(log.startedTime * 1000), 'HH:mm') : "-"}</td>
          <td>{log.finishedTime ? format(new Date(log.finishedTime * 1000), 'HH:mm') : "-"}</td>
          <td>{log.totalTime ? `${getMinuteTimeV2(log.startedTime, log.finishedTime)} นาที` : '-'}</td>
          <td>{log.totalTime > 0 && log.totalEmployeeRT > 0 ? `${log.totalEmployeeRT} คน/${getMinuteTimeV2(log.startedTime, log.finishedTime)*log.totalEmployeeRT} นาที`: '-'}</td>
          <td>{log.totalTime > 0 && log.totalEmployeeOT > 0 ? `${log.totalEmployeeOT} คน/${getMinuteTimeV2(log.startedTime, log.finishedTime)*log.totalEmployeeOT} นาที`: '-'}</td>
          <td>{formatNumber(log.yield)}</td>
          {orderType === OrderType.BULK ? <td>{log.scrap && log.scrap > 0 ? formatNumber(log.scrap) : '-'}</td> : <td>{log.bulkUsedQty && log.bulkUsedQty > 0 ? formatNumber(log.bulkUsedQty) : '-'}</td>}
          <td>-</td>
          {showCreatedBy ? <td>{log.createdBy}</td> : null}
          {isOperationConfirmed(log) ? 
            <td colspan="2" className='text-green-600'>ยืนยันแล้ว</td>
          :
            <>
              {isEdit ? <td className="work-center-edit" onClick={() => onEdit(log.id, log.downtimeCode)}>แก้ไข</td> : <td>-</td>}
              {isEdit ? <td><button className="px-2 py-1 text-xs text-white bg-red-500 rounded" onClick={() => onDelete(log.id, log.downtimeCode)}>ลบ</button></td> : <td>-</td>}
              <td className="work-center-edit"  onClick={() => onViewLog(log.id)}>ดู</td>
            </>
          }
        </tr>
      )}
      {soapBaseLogs.length > 0 ?
      <tr className="bg-[#e2e2e2]">
        <th colSpan={showAllCol ? 15: 13} className="px-2 text-sm text-left">Soap Base</th>
      </tr> : null}
      {soapBaseLogs.map(log =>
        <tr className={ isOperationConfirmed(log) ? 'tableOperationConfirmed' : ''} key={log.id}>
          <td>{log.batchNo ? log.batchNo : '-'}</td>
          <td>{format(new Date(log.postingDate), 'dd-MM-yyyy')}</td>
          {showAllCol ? <td>{displayShift(log.shift)}</td> :null}
          {showAllCol ? <td>{log.mch ? log.mch : '-'}</td> :null}
          <td>{log.startedTime ? format(new Date(log.startedTime * 1000), 'HH:mm') : "-"}</td>
          <td>{log.finishedTime ? format(new Date(log.finishedTime * 1000), 'HH:mm') : "-"}</td>
          <td>{log.totalTime ? `${getMinuteTimeV2(log.startedTime, log.finishedTime)} นาที` : '-'}</td>
          <td>{log.totalTime > 0 && log.totalEmployeeRT > 0 ? `${log.totalEmployeeRT} คน/${getMinuteTimeV2(log.startedTime, log.finishedTime)*log.totalEmployeeRT} นาที`: '-'}</td>
          <td>{log.totalTime > 0 && log.totalEmployeeOT > 0 ? `${log.totalEmployeeOT} คน/${getMinuteTimeV2(log.startedTime, log.finishedTime)*log.totalEmployeeOT} นาที`: '-'}</td>
          <td>{formatNumber(log.bulkUsedQty)}</td>
          <td>-</td>
          <td>-</td>
          {showCreatedBy ? <td>{log.createdBy}</td> : null}
          {isOperationConfirmed(log) ?
            <td colspan="2" className='text-green-600'>ยืนยันแล้ว</td>
          :
            <>
              {isEdit ? <td className="work-center-edit" onClick={() => onEdit(log.id, log.downtimeCode)}>แก้ไข</td> : <td>-</td>}
              {isEdit ? <td><button className="px-2 py-1 text-xs text-white bg-red-500 rounded" onClick={() => onDelete(log.id, log.downtimeCode)}>ลบ</button></td> : <td>-</td>}
              <td className="work-center-edit"  onClick={() => onViewLog(log.id)}>ดู</td>
            </>
          }
        </tr>
      )}
      {downLogs.length > 0 ?
      <tr className="bg-[#e2e2e2]">
        <th colSpan={showAllCol ? 15: 13} className="px-2 text-sm text-left">Down Time</th>
      </tr> : null}
      {downLogs.map(log =>
        <tr className={ isOperationConfirmed(log) ? 'tableOperationConfirmed' : ''} key={log.id}>
          <td>{log.batchNo ? log.batchNo : '-'}</td>
          <td>{format(new Date(log.postingDate), 'dd-MM-yyyy')}</td>
          {showAllCol ? <td>{displayShift(log.shift)}</td> :null}
          {showAllCol ? <td>{log.mch ? log.mch : '-'}</td> :null}
          <td>{log.startedTime ? format(new Date(log.startedTime * 1000), 'HH:mm') : "-"}</td>
          <td>{log.finishedTime ? format(new Date(log.finishedTime * 1000), 'HH:mm') : "-"}</td>
          <td>{displayTotalDownTime(log)}</td>
          <td>{log.totalTime > 0 && log.totalEmployeeRT > 0 ? `${log.totalEmployeeRT} คน/${(getRemainTime(log))*log.totalEmployeeRT} นาที`: '-'}</td>
          <td>{log.totalTime > 0 && log.totalEmployeeOT > 0 ? `${log.totalEmployeeOT} คน/${(getRemainTime(log))*log.totalEmployeeOT} นาที`: '-'}</td>
          <td>-</td>
          <td>-</td>
          <td >
          {displayDowntimeCode(log)}
          </td>
          {showCreatedBy ? <td>{log.createdBy}</td> : null}
          {isOperationConfirmed(log) ?
            <td colspan="2" className='text-green-600'>ยืนยันแล้ว</td>
          :
            <>
              {isEdit ? <td className="work-center-edit" onClick={() => onEdit(log.id, log.downtimeCode)}>แก้ไข</td> : <td>-</td>}
              {isEdit ? <td><button className="px-2 py-1 text-xs text-white bg-red-500 rounded" onClick={() => onDelete(log.id, log.downtimeCode)}>ลบ</button></td> : <td>-</td>}
              <td className="work-center-edit"  onClick={() => onViewLog(log.id)}>ดู</td>
            </>
         }
        </tr>
      )}
    </tbody>
  </table>
}

const displayDowntimeCode = log => {
  if (!log.downtimeCode) return '-'

  if (QCDowntimeCodes.includes(log.downtimeCode) && log.bulkStatus) {
    if (log.bulkStatus === BulkStatus.PASS)
      return <span className='px-1 py-1 text-sm text-green-500 border border-green-500 rounded'>{log.downtimeCode}-{log.bulkStatus}</span>
    if (log.bulkStatus === BulkStatus.HOLD)
      return <span className='px-1 py-1 text-sm text-yellow-500 border border-yellow-500 rounded'>{log.downtimeCode}-{log.bulkStatus}</span>
    if (log.bulkStatus === BulkStatus.REJECT)
      return <span className='px-1 py-1 text-sm text-red-500 border border-red-500 rounded'>{log.downtimeCode}-{log.bulkStatus}</span>
    return <></>
  }

  return <span className='px-1 py-1 text-sm text-red-500 border border-red-500 rounded'>{log.downtimeCode}</span>
}

const displayTotalDownTime = (log) => {
  if (!log.totalTime) return '-'
  if (!log.downtimeBaseTime) return `${getMinuteTimeV2(log.startedTime, log.finishedTime)} นาที`

  return <div>
    <span className="text-gray-500 line-through decoration-red-500">{getMinuteTimeV2(log.startedTime, log.finishedTime)} นาที</span>
    {` ${(getRemainTime(log))} นาที`}
  </div>
}

export const getRemainTime = (log) => {
  let remainTime = getMinuteTimeV2(log.startedTime, log.finishedTime) - (log.downtimeBaseTime ? log.downtimeBaseTime : 0)

  return remainTime < 0 ? 0 : remainTime
}

const displayShift = (shift) => {
  if (!shift) return '-'
  if (shift === "1") return SHIFT.ROMKLAO.display
  if (shift === "2") return SHIFT.MINBURI.display
  return '-'
}
export default OperationLogTable